// extracted by mini-css-extract-plugin
export default {"homepages":"style_homepages__Zn-27","scale":"style_scale__ZIiP5","fade-in":"style_fade-in__B9tDI","span1":"style_span1__-oGeW","span2":"style_span2__lqR-J"};